import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReportsEditComponent } from './reports-edit/reports-edit.component';
import { ReportsEditModule } from './reports-edit/reports-edit.module';

@NgModule({
  imports: [
    CommonModule,
    ReportsEditModule,
    RouterModule.forChild([
      {
        path: "",
        children: [
          {
            path: "",
            redirectTo: "edit",
            pathMatch: "full"
          },
          {
            path: "edit",
            component: ReportsEditComponent
          }
        ]
      }
    ])
  ]
})
export class ReportsModule { }
